import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import {useHistory} from "react-router-dom";
// import {InputAdornment,TextField} from "@mui/material";
// import { Search } from "@mui/icons-material";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {
  let history=useHistory();
  return (
    <Box className="header">
      <Box className="header-title">
          <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      {children && (<Box
    sx={{
      width: 500,
      maxWidth: '100%',
    }}
  >{children}</Box>) }
      {hasHiddenAuthButtons?(<Button
        className="explore-button"
        startIcon={<ArrowBackIcon />}
        variant="text"
        onClick={() => history.push("/")}>Back to explore
      </Button>):
      (localStorage.getItem("token")!==null?
        (<><Stack spacing={1} direction="row" display="flex" alignItems="center">
        <Avatar alt={localStorage.getItem("username")} src="avatar.png" />
        <p>{localStorage.getItem("username")}</p>
        <Button onClick={() => {localStorage.clear();window.location.reload()}} className="button">LOGOUT</Button></Stack>
        </>):
        (<Stack spacing={1} direction="row" display="flex" alignItems="center">
          <Button className="button" onClick={() => history.push("/login")}>LOGIN</Button>
          <Button className="button" variant="contained" onClick={() => history.push("/register")}>REGISTER</Button>
          </Stack>))
      }
    </Box>
  );
};

export default Header;
